/**
 * The hydration gate (plan D22).
 *
 * The workout screens render a skeleton until the stored session has been
 * read. Rendered earlier, the first frame sees "no session": the screen offers
 * to start one, and an action taken there would write an empty session over
 * the stored one. That is silent data loss, so every workout screen — and the
 * shell's live-session button — waits for `useWorkoutHydrated()`.
 *
 * Built on `onRehydrateStorage` (`workout-store.ts`), which also reports a
 * hydration that FAILED; persist's own `onFinishHydration` never fires then,
 * and a gate built on it would show the skeleton forever.
 */
import { useSyncExternalStore } from "react";
import { workoutStore } from "./instance";
import type { WorkoutStore } from "./workout-store";

/** `true` once the stored session has been read (or could not be). */
export function useWorkoutHydrated(given?: WorkoutStore): boolean {
  const store = given ?? workoutStore;
  return useSyncExternalStore(
    store.hydration.subscribe,
    () => store.hydration.getStatus().hydrated,
    () => false
  );
}
